import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { FormControlLabel, Checkbox, Tooltip, Box, InfoIcon } from 'edenred-ui';

export function AutomaticRepeatCheckbox({
  disabled,
  name
}: {
  readonly disabled: boolean;
  readonly name: string;
}) {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const { primaryFrontColor } = useTheme();
  const {
    field: { value, onChange: setValue }
  } = useController({
    name,
    control
  });

  return (
    <Box display="flex" alignItems="flex-start">
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            id={name}
            onChange={setValue}
            disabled={disabled}
          />
        }
        id={`${name}-label`}
        label={
          <Trans
            i18nKey={t(
              'components.manage_benefits.automatic_repeat_field.allow_automatic'
            )}
          />
        }
      />
      <Tooltip
        arrow
        placement="top"
        id={`${name}-tooltip`}
        componentsProps={{
          tooltip: {
            sx: {
              maxWidth: '500px'
            }
          },
          popper: {
            sx: {
              zIndex: 7000
            }
          }
        }}
        title={
          <Trans
            i18nKey={`components.manage_benefits.automatic_repeat_field.automatic_info`}
          />
        }
      >
        <Box id={`${name}-info-icon`}>
          <InfoIcon color={primaryFrontColor} />
        </Box>
      </Tooltip>
    </Box>
  );
}
